import type { PreviewPatientChoice } from "@/api/preview";
import { Select } from "@/ui/Input";

import { LabBarField } from "./LabBarField";

/** Name and gender are the preview target's own fixtures, never free text. */
export function LabPatientField({
  patients,
  value,
  onChange,
  placeholder,
}: {
  patients: readonly PreviewPatientChoice[];
  value: string;
  onChange: (ref: string) => void;
  /** Shown while nothing is chosen, so the tester must pick instead of getting the first patient. */
  placeholder?: string;
}) {
  if (patients.length === 0) {
    return null;
  }
  return (
    <LabBarField label="Patient">
      {({ inputId }) => (
        <Select
          id={inputId}
          className="w-80"
          value={value}
          onChange={(event) => onChange(event.target.value)}
        >
          {placeholder !== undefined && value === "" ? (
            <option value="">{placeholder}</option>
          ) : null}
          {patients.map((patient) => (
            <option key={patient.ref} value={patient.ref}>
              {patient.gender
                ? `${patient.label} (${patient.gender})`
                : patient.label}
            </option>
          ))}
        </Select>
      )}
    </LabBarField>
  );
}
